import { BaseApiService } from './BaseApiService';
import { normalizeYyyyMmDd } from '../../utils/dateUtils';

export type AnalyzeMealResponse = {
  name: string;
  calories: number;
  protein: number;
  carbs: number;
  fats: number;
  confidence: string;
  feedback?: string;
};

export type Meal = {
  id: string;
  userId: string;
  mealDate: string; // YYYY-MM-DD
  name: string;
  label: string | null;
  calories: number;
  protein: number;
  carbs: number;
  fats: number;
  createdAt: string;
};

export type CreateMealRequest = {
  mealDate: string;
  name: string;
  label?: string | null;
  calories: number;
  protein: number;
  carbs: number;
  fats: number;
};

export type MealDayTotal = {
  mealDate: string;
  calories: number;
  protein: number;
  carbs: number;
  fats: number;
};

export class MealsService extends BaseApiService {
  async analyzeMeal(text: string): Promise<AnalyzeMealResponse> {
    return this.post<AnalyzeMealResponse>('/meals/analyze', { text });
  }

  async getMeals(mealDate: string): Promise<Meal[]> {
    const qs = new URLSearchParams({ date: mealDate });
    const res = await this.get<Meal[]>(`/meals?${qs.toString()}`);
    return (res || []).map((m) => ({
      ...m,
      mealDate: normalizeYyyyMmDd(m.mealDate),
    }));
  }

  async saveMeal(payload: CreateMealRequest): Promise<Meal> {
    const res = await this.post<Meal>('/meals', payload);
    return {
      ...res,
      mealDate: normalizeYyyyMmDd(res.mealDate),
    };
  }

  async getMealHistory(days: number = 7): Promise<MealDayTotal[]> {
    const qs = new URLSearchParams({ days: String(days) });
    const res = await this.get<MealDayTotal[]>(`/meals/history?${qs.toString()}`);
    return (res || []).map((d) => ({
      ...d,
      mealDate: normalizeYyyyMmDd(d.mealDate),
    }));
  }
}

export const mealsService = new MealsService();
